// // import React, { useState } from 'react';
// // import { Spinner, Alert } from 'react-bootstrap';
// // import { ntxAPI } from '@API/axiosNeatex';
// // import { useTranslation } from 'react-i18next';
// // import Loading from '@components/Shared/Loader/Loading';
// // import useGetAccounts from '@hooks/Finance/ChartAccountsDetails/useGetAccounts';
// // import Select from 'react-select';
// // import { Card } from '@components/card/card';

// // interface AccountStatement {
// //   id: string;
// //   jE_CATEGORY: string;
// //   jE_CATEGORY_NAME: string;
// //   jE_CATEGORY_NAME2: string;
// //   jE_SOURCE: string;
// //   jE_SOURCE_NAME: string;
// //   jE_SOURCE_NAME2: string;
// //   perioD_ID: string;
// //   perioD_NAME: string;
// //   perioD_NAME2: string;
// //   gL_DATE: string;
// //   amounT_DR: number | null;
// //   amounT_CR: number | null;
// //   jE_LINE_DESCRIPTION: string;
// //   codE_COMBINATION_CODE: string;
// //   account: string;
// //   accounT_NAME: string;
// //   accounT_NAME2: string;
// //   accounT_NUMBER: string;
// //   accounT_PARANT: string;
// //   accounT_TYPE: string;
// //   accounT_LEVEL: number;
// // }

// // const AccountStatementReport: React.FC = () => {
// //   const { t, i18n } = useTranslation();
// //   const [data, setData] = useState<AccountStatement[]>([]);
// //   const [loading, setLoading] = useState<boolean>(false);
// //   const [error, setError] = useState<string | null>(null);

// //   const { OptionsAccounts } = useGetAccounts();

// //   // حالات الفلتر
// //   const [filter, setFilter] = useState({
// //     accountNumber: '',
// //     startDate: '',
// //     endDate: ''
// //   });

// //   // دالة جلب البيانات مع الفلاتر
// //   const fetchData = async () => {
// //     setLoading(true);
// //     setError(null);
// //     try {
// //       const { data } = await ntxAPI.get<{ succeeded: boolean; data: AccountStatement[]; message?: string }>(
// //         'Reports/GetAccountStatement',
// //         {
// //           params: {
// //             ACCOUNT_NUMBER: filter.accountNumber,
// //             StartDate: filter.startDate,
// //             EndDate: filter.endDate
// //           }
// //         }
// //       );
// //       if (data.succeeded === true) {
// //         setData(data.data || []);
// //       } else {
// //         setError(data.message || 'حدث خطأ غير معروف');
// //       }
// //     } catch (err) {
// //       setError(err instanceof Error ? err.message : 'حدث خطأ غير معروف');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const resetFilters = () => {
// //     setFilter({
// //       accountNumber: '',
// //       startDate: '',
// //       endDate: ''
// //     });
// //   };

// //   const formatCurrency = (amount: number | null): string => {
// //     if (amount === null) return '-';
// //     return new Intl.NumberFormat('en-US', {
// //       minimumFractionDigits: 2,
// //       maximumFractionDigits: 2
// //     }).format(amount);
// //   };

// //   // const formatDate = (dateString: string): string => {
// //   //   return new Date(dateString).toLocaleDateString('en-US');
// //   // };

// //   // حساب الرصيد لكل إدخال
// //   const calculateBalance = (dr: number | null, cr: number | null) => {
// //     const debit = dr || 0;
// //     const credit = cr || 0;
// //     return debit - credit;
// //   };

// //   // حساب الإجماليات
// //   const calculateTotals = () => {
// //     const totalDebit = data.reduce((sum, item) => sum + (item.amounT_DR || 0), 0);
// //     const totalCredit = data.reduce((sum, item) => sum + (item.amounT_CR || 0), 0);
// //     const totalBalance = data.reduce((sum, item) => sum + calculateBalance(item.amounT_DR, item.amounT_CR), 0);

// //     return { totalDebit, totalCredit, totalBalance };
// //   };

// //   const { totalDebit, totalCredit, totalBalance } = calculateTotals();

// //   return (
// //     <>
// //       <Card className=' mb-4'>
// //         <div className='card-header d-flex justify-content-between align-items-center'>
// //           <h6 className='mb-0'>
// //             <i className='fas fa-file-invoice me-2'></i>
// //             كشف الحساب
// //             <span className='badge bg-primary ms-2'>التقرير المالي</span>
// //           </h6>
// //           <div>
// //             <span className='badge bg-theme me-2'>إجمالي الحركات: {data?.length || 0}</span>
// //             <span className='badge bg-success'>الرصيد الإجمالي: {formatCurrency(totalBalance)}</span>
// //           </div>
// //         </div>

// //         <div className='card-body p-0'>
// //           {/* قسم الفلاتر */}
// //           <div className='p-3 border-bottom'>
// //             <div className='row mb-3'>
// //               <div className='col-lg-6 mb-2'>
// //                 <div className='input-group flex-nowrap'>
// //                   <span className='input-group-text fw-bold'>رقم الحساب</span>

// //                   <Select
// //                     classNamePrefix='react-select'
// //                     className={`w-100`}
// //                     isLoading={loading}
// //                     isSearchable
// //                     isClearable
// //                     name='accountId'
// //                     options={OptionsAccounts}
// //                     placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
// //                     onChange={(option: any) => {
// //                       // )
// //                       setFilter({ ...filter, accountNumber: option === null ? null : option.accountNumber });
// //                     }}
// //                     value={OptionsAccounts?.find(f => f.value === filter.accountNumber)}
// //                   />
// //                 </div>
// //               </div>

// //               <div className='col-lg-3 mb-2'>
// //                 <div className='input-group flex-nowrap'>
// //                   <span className='input-group-text fw-bold'>من تاريـخ</span>
// //                   <input
// //                     type='date'
// //                     autoComplete='off'
// //                     className='form-control'
// //                     value={filter.startDate}
// //                     onChange={e => {
// //                       setFilter({ ...filter, startDate: e.target.value });
// //                     }}
// //                   />
// //                 </div>
// //               </div>

// //               <div className='col-lg-3 mb-2'>
// //                 <div className='input-group flex-nowrap'>
// //                   <span className='input-group-text fw-bold'>إلى تاريـخ</span>
// //                   <input
// //                     type='date'
// //                     autoComplete='off'
// //                     className='form-control'
// //                     value={filter.endDate}
// //                     onChange={e => {
// //                       setFilter({ ...filter, endDate: e.target.value });
// //                     }}
// //                   />
// //                 </div>
// //               </div>
// //             </div>

// //             <div className='row'>
// //               <div className='col-lg-6'>
// //                 <button className='btn btn-secondary me-2' onClick={resetFilters}>
// //                   إعادة تعيين
// //                 </button>
// //                 <button className='btn btn-theme' onClick={fetchData} disabled={loading}>
// //                   {loading ? (
// //                     <>
// //                       <Spinner
// //                         as='span'
// //                         animation='border'
// //                         size='sm'
// //                         role='status'
// //                         aria-hidden='true'
// //                         className='me-2'
// //                       />
// //                       جاري التحميل...
// //                     </>
// //                   ) : (
// //                     'تحميل التقرير'
// //                   )}
// //                 </button>
// //               </div>
// //             </div>

// //             {error && (
// //               <Alert variant='danger' className='mt-3 mb-0'>
// //                 خطأ في تحميل البيانات: {error}
// //               </Alert>
// //             )}
// //           </div>

// //           {/* قسم النتائج */}
// //           <Loading loading={loading} error={error} Type='Dots'>
// //             <div className='table-responsive'>
// //               <table className='table table-hover mb-0'>
// //                 <thead className='table-actived fw-bold'>
// //                   <tr>
// //                     <th className='text-center small'>التاريخ</th>
// //                     <th className='text-center small'>الحساب</th>
// //                     <th className='text-center small'>رقم الحساب</th>
// //                     <th className='text-center small'>التصنيف</th>
// //                     <th className='text-center small'>المصدر</th>
// //                     <th className='text-center small'>الوصف</th>
// //                     <th className='text-center small'>مدين</th>
// //                     <th className='text-center small'>دائن</th>
// //                     <th className='text-center small'>الرصيد</th>
// //                   </tr>
// //                 </thead>
// //                 <tbody>
// //                   {data?.length > 0 ? (
// //                     data.map((item, index) => {
// //                       const balance = calculateBalance(item.amounT_DR, item.amounT_CR);
// //                       return (
// //                         <tr key={`${item.id}-${index}`}>
// //                           <td className='text-center align-middle'>
// //                             <strong>{item.gL_DATE?.split('T')[0]}</strong>
// //                           </td>
// //                           <td className='text-center align-middle'>
// //                             <strong>
// //                               {i18n.language === 'en' ? item.accounT_NAME : item.accounT_NAME2 || item.accounT_NAME}
// //                             </strong>
// //                           </td>
// //                           <td className='text-center align-middle'>
// //                             <strong>{item.accounT_NUMBER}</strong>
// //                           </td>
// //                           <td className='text-center align-middle'>
// //                             <strong>
// //                               {i18n.language === 'en'
// //                                 ? item.jE_CATEGORY_NAME
// //                                 : item.jE_CATEGORY_NAME2 || item.jE_CATEGORY_NAME}
// //                             </strong>
// //                           </td>
// //                           <td className='text-center align-middle'>
// //                             <strong>
// //                               {i18n.language === 'en'
// //                                 ? item.jE_SOURCE_NAME
// //                                 : item.jE_SOURCE_NAME2 || item.jE_SOURCE_NAME}
// //                             </strong>
// //                           </td>
// //                           <td className='text-center align-middle'>{item.jE_LINE_DESCRIPTION || '-'}</td>
// //                           <td className='text-center align-middle'>
// //                             <span className='badge bg-danger fs-6'>{formatCurrency(item.amounT_DR)}</span>
// //                           </td>
// //                           <td className='text-center align-middle'>
// //                             <span className='badge bg-success fs-6'>{formatCurrency(item.amounT_CR)}</span>
// //                           </td>
// //                           <td className='text-center align-middle'>
// //                             <span
// //                               className={`badge fs-6 ${
// //                                 balance > 0 ? 'bg-danger' : balance < 0 ? 'bg-success' : 'bg-secondary'
// //                               }`}
// //                             >
// //                               {formatCurrency(Math.abs(balance))}
// //                             </span>
// //                           </td>
// //                         </tr>
// //                       );
// //                     })
// //                   ) : (
// //                     <tr>
// //                       <td colSpan={9} className='text-center py-4 text-muted'>
// //                         <i className='fa fa-inbox fa-2x mb-2'></i>
// //                         <br />
// //                         لا توجد سجلات للعرض
// //                       </td>
// //                     </tr>
// //                   )}
// //                 </tbody>
// //               </table>
// //             </div>
// //           </Loading>
// //         </div>

// //         <div className='card-footer d-flex justify-content-between align-items-center'>
// //           <div className='text-muted small'>
// //             عرض {data?.length || 0} من {data?.length || 0} حركة
// //           </div>
// //           <div className='d-flex gap-3'>
// //             <span className='text-danger fw-bold'>إجمالي المدين: {formatCurrency(totalDebit)}</span>
// //             <span className='text-success fw-bold'>إجمالي الدائن: {formatCurrency(totalCredit)}</span>
// //             <span
// //               className={`fw-bold ${
// //                 totalBalance > 0 ? 'text-danger' : totalBalance < 0 ? 'text-success' : 'text-muted'
// //               }`}
// //             >
// //               الرصيد النهائي: {formatCurrency(Math.abs(totalBalance))}
// //             </span>
// //           </div>
// //         </div>
// //       </Card>
// //     </>
// //   );
// // };

// // export default AccountStatementReport;

// import React, { useState, useMemo } from 'react';
// import { ntxAPI } from '@API/axiosNeatex';
// import { useTranslation } from 'react-i18next';
// import Loading from '@components/Shared/Loader/Loading';
// import useGetAccounts from '@hooks/Finance/ChartAccountsDetails/useGetAccounts';
// import Select from 'react-select';
// import { Card, CardFooter, CardHeader } from '@components/card/card';

// interface AccountStatement {
//   id: string;
//   jE_CATEGORY_NAME: string;
//   jE_CATEGORY_NAME2: string;
//   jE_SOURCE_NAME: string;
//   jE_SOURCE_NAME2: string;
//   gL_DATE: string;
//   amounT_DR: number | null;
//   amounT_CR: number | null;
//   jE_LINE_DESCRIPTION: string;
//   accounT_NAME: string;
//   accounT_NAME2: string;
//   accounT_NUMBER: string;
// }

// const AccountStatementReport: React.FC = () => {
//   const { t, i18n } = useTranslation();
//   const isAr = i18n.language !== 'en';

//   const [data, setData] = useState<AccountStatement[]>([]);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);

//   const { OptionsAccounts, loading: loadingAccounts } = useGetAccounts();

//   const [filter, setFilter] = useState({
//     accountNumber: '',
//     startDate: '',
//     endDate: ''
//   });

//   const fetchData = async () => {
//     if (!filter.accountNumber) return;
//     setLoading(true);
//     setError(null);
//     try {
//       const { data } = await ntxAPI.get<{ succeeded: boolean; data: AccountStatement[]; message?: string }>(
//         'Reports/GetAccountStatement',
//         {
//           params: {
//             ACCOUNT_NUMBER: filter.accountNumber,
//             StartDate: filter.startDate,
//             EndDate: filter.endDate
//           }
//         }
//       );
//       if (data.succeeded) {
//         setData(data.data || []);
//       } else {
//         setError(data.message || 'Error');
//       }
//     } catch (err) {
//       setError(err instanceof Error ? err.message : 'Error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetFilters = () => {
//     setFilter({ accountNumber: '', startDate: '', endDate: '' });
//     setData([]);
//   };

//   const formatNumber = (num: number | null) => {
//     return new Intl.NumberFormat('en-US', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(num || 0);
//   };

//   const totals = useMemo(() => {
//     const dr = data.reduce((sum, item) => sum + (item.amounT_DR || 0), 0);
//     const cr = data.reduce((sum, item) => sum + (item.amounT_CR || 0), 0);
//     return { dr, cr, bal: dr - cr };
//   }, [data]);

//   return (
//     <>
//       <CardHeader className='mb-3'>
//         <div className='row g-2 align-items-center'>
//           {/* رقم الحساب */}
//           <div className='col-lg-5'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-list-ol text-primary'></i>
//                 <span className='text-danger ms-1'>*</span>
//               </span>
//               <Select
//                 classNamePrefix='react-select'
//                 className='flex-grow-1'
//                 isLoading={loadingAccounts}
//                 isSearchable
//                 isClearable
//                 options={OptionsAccounts}
//                 placeholder={isAr ? 'رقم الحساب' : 'Account Number'}
//                 value={OptionsAccounts?.find(f => f.accountNumber === filter.accountNumber)}
//                 onChange={(opt: any) => setFilter({ ...filter, accountNumber: opt?.accountNumber || '' })}
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* من تاريخ */}
//           <div className='col-lg-2'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-calendar'></i>
//               </span>
//               <input
//                 type='date'
//                 className='form-control'
//                 value={filter.startDate}
//                 onChange={e => setFilter({ ...filter, startDate: e.target.value })}
//               />
//             </div>
//           </div>

//           {/* إلى تاريخ */}
//           <div className='col-lg-2'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-calendar'></i>
//               </span>
//               <input
//                 type='date'
//                 className='form-control'
//                 value={filter.endDate}
//                 onChange={e => setFilter({ ...filter, endDate: e.target.value })}
//                 min={filter.startDate}
//               />
//             </div>
//           </div>

//           {/* الأزرار */}
//           <div className='col-lg-3 text-end'>
//             <button className='btn btn-outline-secondary me-2' onClick={resetFilters} title={t('ClearFilters')}>
//               <i className='fas fa-times fa-fw'></i>
//             </button>
//             <button className='btn btn-theme me-2' onClick={fetchData} disabled={!filter.accountNumber || loading}>
//               <i className='fas fa-filter fa-fw'></i>
//             </button>
//             <button className='btn btn-outline-success' disabled={data.length === 0}>
//               <i className='fas fa-file-excel fa-fw'></i>
//             </button>
//           </div>
//         </div>
//       </CardHeader>

//       <Loading loading={loading} error={error}>
//         <Card className='mb-4'>
//           <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
//             <table className='table table-hover mb-0'>
//               <thead className='sticky-top' style={{ top: 0, zIndex: 10 }}>
//                 <tr className='bg-theme bg-opacity-35' style={{ backdropFilter: 'blur(20px)' }}>
//                   <th className='small' style={{ minWidth: '110px' }}>
//                     {t('Date')}
//                   </th>
//                   <th className='small' style={{ minWidth: '150px' }}>
//                     {isAr ? 'الحساب' : 'Account'}
//                   </th>
//                   <th className='small' style={{ minWidth: '120px' }}>
//                     {isAr ? 'التصنيف' : 'Category'}
//                   </th>
//                   <th className='small text-end' style={{ minWidth: '120px' }}>
//                     {t('Debit')}
//                   </th>
//                   <th className='small text-end' style={{ minWidth: '120px' }}>
//                     {t('Credit')}
//                   </th>
//                   <th className='small text-end' style={{ minWidth: '120px' }}>
//                     {isAr ? 'الرصيد' : 'Balance'}
//                   </th>
//                   <th className='small' style={{ minWidth: '300px' }}>
//                     {t('Description')}
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {data.length > 0 ? (
//                   data.map((item, index) => {
//                     const rowBalance = (item.amounT_DR || 0) - (item.amounT_CR || 0);
//                     return (
//                       <tr key={`${item.id}-${index}`} className='align-middle'>
//                         <td>
//                           <div className='fw-medium'>{item.gL_DATE?.split('T')[0]}</div>
//                         </td>
//                         <td>
//                           <div className='fw-bold small'>
//                             {isAr ? item.accounT_NAME2 || item.accounT_NAME : item.accounT_NAME}
//                           </div>
//                           <div className='text-muted tiny'>{item.accounT_NUMBER}</div>
//                         </td>
//                         <td>
//                           <span className='badge bg-theme bg-opacity-70  border'>
//                             {isAr ? item.jE_CATEGORY_NAME2 || item.jE_CATEGORY_NAME : item.jE_CATEGORY_NAME}
//                           </span>
//                         </td>
//                         <td className='text-end'>
//                           {item.amounT_DR ? (
//                             <div className='fw-bold '>{formatNumber(item.amounT_DR)}</div>
//                           ) : (
//                             <div className='text-muted opacity-50'>0.00</div>
//                           )}
//                         </td>
//                         <td className='text-end'>
//                           {item.amounT_CR ? (
//                             <div className='fw-bold  '>{formatNumber(item.amounT_CR)}</div>
//                           ) : (
//                             <div className='text-muted opacity-50'>0.00</div>
//                           )}
//                         </td>
//                         <td className='text-center bg-secondary bg-opacity-10'>
//                           <div className={`fw-bold fs-6 ${rowBalance < 0 ? 'text-danger' : 'text-success'}`}>
//                             {formatNumber(rowBalance)}
//                           </div>
//                         </td>
//                         <td>
//                           <div className='small text-muted'>{item.jE_LINE_DESCRIPTION || '—'}</div>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : !loading && !filter.accountNumber ? (
//                   <tr>
//                     <td colSpan={7} className='text-center py-5'>
//                       <div className='text-muted'>
//                         <i className='fas fa-search fa-3x mb-3 opacity-50 text-warning'></i>
//                         <h6 className='text-warning'>
//                           {isAr ? 'الرجاء اختيار الحساب أولاً' : 'Please select account first'}
//                         </h6>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : !loading ? (
//                   <tr>
//                     <td colSpan={7} className='text-center py-5'>
//                       <div className='text-muted'>
//                         <i className='fas fa-file-invoice fa-3x mb-3 opacity-50'></i>
//                         <h6>{t('NoData')}</h6>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : null}
//               </tbody>
//             </table>
//           </div>

//           <CardFooter>
//             <div className='d-flex justify-content-between align-items-center flex-wrap gap-3 w-100'>
//               <div className='text-muted small'>
//                 {isAr ? 'إجمالي الحركات:' : 'Total Trans:'} <strong>{data.length}</strong>
//               </div>
//               <div className='d-flex gap-4'>
//                 <div className='text-end'>
//                   <div className='tiny text-muted uppercase'>{t('Debit')}</div>
//                   <div className='fw-bold text-dark'>{formatNumber(totals.dr)}</div>
//                 </div>
//                 <div className='text-end'>
//                   <div className='tiny text-muted uppercase'>{t('Credit')}</div>
//                   <div className='fw-bold text-dark'>{formatNumber(totals.cr)}</div>
//                 </div>
//                 <div className='text-end border-start ps-4'>
//                   <div className='tiny text-muted uppercase'>{isAr ? 'صافي الرصيد' : 'NET BALANCE'}</div>
//                   <div className={`fw-bold fs-5 ${totals.bal < 0 ? 'text-danger' : 'text-success'}`}>
//                     {formatNumber(totals.bal)}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </CardFooter>
//         </Card>
//       </Loading>
//     </>
//   );
// };

// export default AccountStatementReport;


import React, { useState, useMemo } from 'react';
import { ntxAPI } from '@API/axiosNeatex';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';
import useGetAccounts from '@hooks/Finance/ChartAccountsDetails/useGetAccounts';
import Select from 'react-select';
import { Card, CardFooter, CardHeader } from '@components/card/card';
import * as XLSX from 'xlsx';

interface AccountStatement {
  id: string;
  jE_CATEGORY_NAME: string;
  jE_CATEGORY_NAME2: string;
  jE_SOURCE_NAME: string;
  jE_SOURCE_NAME2: string;
  gL_DATE: string;
  amounT_DR: number | null;
  amounT_CR: number | null;
  jE_LINE_DESCRIPTION: string;
  accounT_NAME: string;
  accounT_NAME2: string;
  accounT_NUMBER: string;
}

const AccountStatementReport: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language !== 'en';

  const [data, setData] = useState<AccountStatement[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const { OptionsAccounts, loading: loadingAccounts } = useGetAccounts();

  const [filter, setFilter] = useState({
    accountNumber: '',
    startDate: '',
    endDate: ''
  });

  const fetchData = async () => {
    if (!filter.accountNumber) return;
    setLoading(true);
    setError(null);
    try {
      const { data } = await ntxAPI.get<{ succeeded: boolean; data: AccountStatement[]; message?: string }>(
        'Reports/GetAccountStatement',
        {
          params: {
            ACCOUNT_NUMBER: filter.accountNumber,
            StartDate: filter.startDate,
            EndDate: filter.endDate
          }
        }
      );

      if (data.succeeded) {
        setData(data.data || []);
      } else {
        setError(data.message || 'Error');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error');
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    setFilter({ accountNumber: '', startDate: '', endDate: '' });
    setData([]);
  };

  const formatNumber = (num: number | null) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num || 0);
  };

  const totals = useMemo(() => {
    const dr = data.reduce((sum, item) => sum + (item.amounT_DR || 0), 0);
    const cr = data.reduce((sum, item) => sum + (item.amounT_CR || 0), 0);
    return { dr, cr, bal: dr - cr };
  }, [data]);

  const exportToExcel = () => {
    if (!data?.length) return;

    const title = isAr ? 'كشف حساب' : 'Account Statement';
    const sheetName = isAr ? 'كشف حساب' : 'Statement';

    const from = filter.startDate || '';
    const to = filter.endDate || '';

    // Header / Meta
    const meta: any[][] = [
      [title],
      [],
      [isAr ? 'رقم الحساب' : 'Account Number', filter.accountNumber],
      [isAr ? 'الفترة' : 'Period', `${from || '...'} - ${to || '...'}`],
      []
    ];

    // Table columns
    const columns = [
      isAr ? 'م' : '#',
      isAr ? 'التاريخ' : 'Date',
      isAr ? 'رقم الحساب' : 'Account No',
      isAr ? 'اسم الحساب' : 'Account',
      isAr ? 'التصنيف' : 'Category',
      isAr ? 'مدين' : 'Debit',
      isAr ? 'دائن' : 'Credit',
      isAr ? 'الرصيد' : 'Balance',
      isAr ? 'البيان' : 'Description'
    ];

    // Rows
    const body = data.map((item, idx) => {
      const dr = item.amounT_DR ?? 0;
      const cr = item.amounT_CR ?? 0;
      const bal = dr - cr;

      return [
        idx + 1,
        item.gL_DATE?.split('T')?.[0] || '',
        item.accounT_NUMBER || '',
        isAr ? item.accounT_NAME2 || item.accounT_NAME : item.accounT_NAME || '',
        isAr ? item.jE_CATEGORY_NAME2 || item.jE_CATEGORY_NAME : item.jE_CATEGORY_NAME || '',
        dr,
        cr,
        bal,
        item.jE_LINE_DESCRIPTION || ''
      ];
    });

    // Build worksheet
    const ws = XLSX.utils.aoa_to_sheet(meta);
    XLSX.utils.sheet_add_aoa(ws, [columns], { origin: 'A6' });
    XLSX.utils.sheet_add_aoa(ws, body, { origin: 'A7' });

    // Totals row (after body)
    const totalsRowExcelIndex = 7 + body.length; // Excel rows are 1-based
    XLSX.utils.sheet_add_aoa(
      ws,
      [
        [
          '',
          '',
          '',
          '',
          isAr ? 'الإجمالي' : 'TOTAL',
          totals.dr,
          totals.cr,
          totals.bal,
          ''
        ]
      ],
      { origin: `A${totalsRowExcelIndex}` }
    );

    // Column widths
    ws['!cols'] = [
      { wch: 6 }, // #
      { wch: 12 }, // Date
      { wch: 18 }, // Account No
      { wch: 28 }, // Account
      { wch: 18 }, // Category
      { wch: 14 }, // Debit
      { wch: 14 }, // Credit
      { wch: 14 }, // Balance
      { wch: 50 } // Description
    ];

    // Number formats (Debit/Credit/Balance)
    const startRow0 = 6; // A7 => r=6 (0-based)
    const endRow0 = 6 + body.length; // includes totals row
    const moneyCols = [5, 6, 7]; // F,G,H (0-based)

    for (let r = startRow0; r <= endRow0; r++) {
      for (const c of moneyCols) {
        const addr = XLSX.utils.encode_cell({ r, c });
        const cell = ws[addr];
        if (cell && typeof cell.v === 'number') cell.z = '#,##0.00';
      }
    }

    // Workbook
    const wb = XLSX.utils.book_new();
    (wb as any).Workbook = { Views: [{ RTL: isAr }] };
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    const safeFrom = filter.startDate || 'ALL';
    const safeTo = filter.endDate || 'ALL';
    const fileName = `AccountStatement_${filter.accountNumber}_${safeFrom}_${safeTo}.xlsx`;

    XLSX.writeFile(wb, fileName, { compression: true });
  };

  return (
    <>
      <CardHeader className='mb-3'>
        <div className='row g-2 align-items-center'>
          {/* رقم الحساب */}
          <div className='col-lg-5'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-list-ol text-primary'></i>
                <span className='text-danger ms-1'>*</span>
              </span>
              <Select
                classNamePrefix='react-select'
                className='flex-grow-1'
                isLoading={loadingAccounts}
                isSearchable
                isClearable
                options={OptionsAccounts}
                placeholder={isAr ? 'رقم الحساب' : 'Account Number'}
                value={OptionsAccounts?.find((f: any) => f.accountNumber === filter.accountNumber)}
                onChange={(opt: any) => setFilter({ ...filter, accountNumber: opt?.accountNumber || '' })}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* من تاريخ */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={filter.startDate}
                onChange={e => setFilter({ ...filter, startDate: e.target.value })}
              />
            </div>
          </div>

          {/* إلى تاريخ */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={filter.endDate}
                onChange={e => setFilter({ ...filter, endDate: e.target.value })}
                min={filter.startDate}
              />
            </div>
          </div>

          {/* الأزرار */}
          <div className='col-lg-3 text-end'>
            <button className='btn btn-outline-secondary me-2' onClick={resetFilters} title={t('ClearFilters')}>
              <i className='fas fa-times fa-fw'></i>
            </button>

            <button className='btn btn-theme me-2' onClick={fetchData} disabled={!filter.accountNumber || loading}>
              <i className='fas fa-filter fa-fw'></i>
            </button>

            <button
              className='btn btn-outline-success'
              disabled={data.length === 0}
              onClick={exportToExcel}
              title={isAr ? 'تصدير إلى Excel' : 'Export to Excel'}
            >
              <i className='fas fa-file-excel fa-fw'></i>
            </button>
          </div>
        </div>
      </CardHeader>

      <Loading loading={loading} error={error}>
        <Card className='mb-4'>
          <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
            <table className='table table-hover mb-0'>
              <thead className='sticky-top' style={{ top: 0, zIndex: 10 }}>
                <tr className='bg-theme bg-opacity-35' style={{ backdropFilter: 'blur(20px)' }}>
                  <th className='small' style={{ minWidth: '110px' }}>
                    {t('Date')}
                  </th>
                  <th className='small' style={{ minWidth: '150px' }}>
                    {isAr ? 'الحساب' : 'Account'}
                  </th>
                  <th className='small' style={{ minWidth: '120px' }}>
                    {isAr ? 'التصنيف' : 'Category'}
                  </th>
                  <th className='small text-end' style={{ minWidth: '120px' }}>
                    {t('Debit')}
                  </th>
                  <th className='small text-end' style={{ minWidth: '120px' }}>
                    {t('Credit')}
                  </th>
                  <th className='small text-end' style={{ minWidth: '120px' }}>
                    {isAr ? 'الرصيد' : 'Balance'}
                  </th>
                  <th className='small' style={{ minWidth: '300px' }}>
                    {t('Description')}
                  </th>
                </tr>
              </thead>

              <tbody>
                {data.length > 0 ? (
                  data.map((item, index) => {
                    const rowBalance = (item.amounT_DR || 0) - (item.amounT_CR || 0);
                    return (
                      <tr key={`${item.id}-${index}`} className='align-middle'>
                        <td>
                          <div className='fw-medium'>{item.gL_DATE?.split('T')[0]}</div>
                        </td>
                        <td>
                          <div className='fw-bold small'>
                            {isAr ? item.accounT_NAME2 || item.accounT_NAME : item.accounT_NAME}
                          </div>
                          <div className='text-muted tiny'>{item.accounT_NUMBER}</div>
                        </td>
                        <td>
                          <span className='badge bg-theme bg-opacity-70 border'>
                            {isAr ? item.jE_CATEGORY_NAME2 || item.jE_CATEGORY_NAME : item.jE_CATEGORY_NAME}
                          </span>
                        </td>
                        <td className='text-end'>
                          {item.amounT_DR ? (
                            <div className='fw-bold'>{formatNumber(item.amounT_DR)}</div>
                          ) : (
                            <div className='text-muted opacity-50'>0.00</div>
                          )}
                        </td>
                        <td className='text-end'>
                          {item.amounT_CR ? (
                            <div className='fw-bold'>{formatNumber(item.amounT_CR)}</div>
                          ) : (
                            <div className='text-muted opacity-50'>0.00</div>
                          )}
                        </td>
                        <td className='text-center bg-secondary bg-opacity-10'>
                          <div className={`fw-bold fs-6 ${rowBalance < 0 ? 'text-danger' : 'text-success'}`}>
                            {formatNumber(rowBalance)}
                          </div>
                        </td>
                        <td>
                          <div className='small text-muted'>{item.jE_LINE_DESCRIPTION || '—'}</div>
                        </td>
                      </tr>
                    );
                  })
                ) : !loading && !filter.accountNumber ? (
                  <tr>
                    <td colSpan={7} className='text-center py-5'>
                      <div className='text-muted'>
                        <i className='fas fa-search fa-3x mb-3 opacity-50 text-warning'></i>
                        <h6 className='text-warning'>{isAr ? 'الرجاء اختيار الحساب أولاً' : 'Please select account first'}</h6>
                      </div>
                    </td>
                  </tr>
                ) : !loading ? (
                  <tr>
                    <td colSpan={7} className='text-center py-5'>
                      <div className='text-muted'>
                        <i className='fas fa-file-invoice fa-3x mb-3 opacity-50'></i>
                        <h6>{t('NoData')}</h6>
                      </div>
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
          

          <CardFooter>
            <div className='d-flex justify-content-between align-items-center flex-wrap gap-3 w-100'>
              <div className='text-muted small'>
                {isAr ? 'إجمالي الحركات:' : 'Total Trans:'} <strong>{data.length}</strong>
              </div>

              <div className='d-flex gap-4'>
                <div className='text-end'>
                  <div className='tiny text-muted uppercase'>{t('Debit')}</div>
                  <div className='fw-bold text-dark'>{formatNumber(totals.dr)}</div>
                </div>

                <div className='text-end'>
                  <div className='tiny text-muted uppercase'>{t('Credit')}</div>
                  <div className='fw-bold text-dark'>{formatNumber(totals.cr)}</div>
                </div>

                <div className='text-end border-start ps-4'>
                  <div className='tiny text-muted uppercase'>{isAr ? 'صافي الرصيد' : 'NET BALANCE'}</div>
                  <div className={`fw-bold fs-5 ${totals.bal < 0 ? 'text-danger' : 'text-success'}`}>
                    {formatNumber(totals.bal)}
                  </div>
                </div>
              </div>
            </div>
          </CardFooter>
        </Card>
      </Loading>
    </>
  );
};

export default AccountStatementReport;